import o from "./highrise1300.mjs";
import l from "./highrise1316.mjs";
function f(a) {
  for (var t = l(a), r = t.length; r--; ) {
    var e = t[r], i = a[e];
    t[r] = [e, i, o(i)];
  }
  return t;
}
export {
  f as default
};
